interface MobileMenuProps {
  menuOpen: boolean;
  onClose: () => void;
}

function scrollOrNavigate(selector: string, onClose: () => void) {
  const section = document.querySelector(selector);
  if (section) {
    section.scrollIntoView({ behavior: 'smooth' });
    onClose();
  } else {
    window.location.href = '/' + (selector === '[data-what-is-section]' ? '#about' : selector === '[data-download-section]' ? '#download' : '');
  }
}

function MobileMenu({ menuOpen, onClose }: MobileMenuProps) {
  if (!menuOpen) return null;

  const isHome = window.location.pathname === '/' || window.location.pathname === '/download';

  return (
    <div style={styles.mobileMenu}>
      <a
        style={styles.mobileNavLink}
        href="/"
        onClick={(e) => {
          if (isHome) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
            onClose();
          }
        }}
      >
        Home
      </a>
      <a
        style={styles.mobileNavLink}
        href="/#download"
        onClick={(e) => {
          if (isHome) {
            e.preventDefault();
            scrollOrNavigate('[data-download-section]', onClose);
          }
        }}
      >
        Download
      </a>
      <a
        style={styles.mobileNavLink}
        href="/blog"
        onClick={onClose}
      >
        Blog
      </a>
    </div>
  );
}

export default MobileMenu;

const styles = {
  mobileMenu: {
    position: 'fixed' as const,
    top: '48px',
    left: 0,
    right: 0,
    background: 'rgba(255, 255, 255, 0.98)',
    backdropFilter: 'blur(10px)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '20px',
    zIndex: 999,
  },

  mobileNavLink: {
    color: '#64748b',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '1.1rem',
    padding: '12px 0',
    borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
    cursor: 'pointer',
  },
};
